// Fixed version of OrderCurrent.jsx
/* eslint-disable react-hooks/rules-of-hooks */
import { useEffect, useState } from 'react'

import L from 'leaflet'
import 'leaflet-routing-machine'
import { createControlComponent } from '@react-leaflet/core'

import './OrderCurrent.scss'
import 'leaflet/dist/leaflet.css'

import { Link, useNavigate, useParams } from 'react-router-dom'

import iconUrl from '../../../assets/svg/Location.svg'
import DeliveryIconNew from '../../../assets/svg/DeliveryMotor.svg'

import DeliveryIcon from '../../../assets/svg/PeykProfileIcon.svg'
import PeykProfileIcon from '../../../assets/svg/PeykProfile.svg'
import PeykMenuOrderActive from '../../../assets/svg/PeykMenuOrder-mini-active.svg'
import PeykMenuAnalytic from '../../../assets/svg/PeykMenuAnalytic-mini.svg'
import PeykMenuMessage from '../../../assets/svg/PeykMenuMessage-mini.svg'
import PeykMenuOrderDone from '../../../assets/svg/PeykMenuOrderDone-mini.svg'
import PeykHat from '../../../assets/svg/PeykHat-mini.svg'

import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet'
import { get, post } from '../../../services/https'

// Leaflet Icon FIX
const deliveryMotorIcon = new L.Icon({
  iconUrl: DeliveryIconNew,
  iconSize: [45, 55],
  iconAnchor: [22, 55],
  popupAnchor: [0, -55]
})

const locationIcon = new L.Icon({
  iconUrl: iconUrl,
  iconSize: [45, 45],
  iconAnchor: [22, 55],
  popupAnchor: [0, -55]
})

export default function OrderCurrent() {
  const [customerName, setCustomerName] = useState('')
  const [address, setAddress] = useState('')
  const [name, setName] = useState('...')

  const [postitionLat, setPositionLat] = useState(null)
  const [postitionLong, setPositionLong] = useState(null)

  const [restaurantLat] = useState(37.27579)
  const [restaurantLong] = useState(49.937)

  const [peykLat, setPeykLat] = useState(null)
  const [peykLong, setPeykLong] = useState(null)

  const navigate = useNavigate()
  const param = useParams()

  // Routing Machine FIX: Ensure map instance exists
  const createRoutingMachine = ({ to }) => {
    const instance = L.Routing.control({
      waypoints: [
        L.latLng(restaurantLat, restaurantLong),
        L.latLng(to[0], to[1])
      ],
      lineOptions: {
        styles: [{ color: '#6FA1EC', weight: 4 }]
      },
      addWaypoints: false,
      draggableWaypoints: false,
      routeWhileDragging: false,
      show: false,
      createMarker: function (i, waypoint, n) {
        const marker = L.marker(waypoint.latLng, {
          draggable: false,
          bounceOnAdd: false,
          bounceOnAddOptions: {
            duration: 1000,
            height: 800,
          },
          icon: L.icon({
            iconUrl: iconUrl,
            iconSize: [38, 95],
            iconAnchor: [22, 94],
            popupAnchor: [-3, -76],
            shadowSize: [68, 95],
            shadowAnchor: [22, 94]
          })
        });
        return marker;
      }
})

    return instance
  }

  const RoutingMachine = createControlComponent(createRoutingMachine)

  // Live marker component
  function PeykMarker({ lat, lng }) {
    const map = useMap()

    useEffect(() => {
      if (lat && lng) {
        map.flyTo([lat, lng], 15, { duration: 1.3 })
      }
    }, [lat, lng, map])

    if (!lat || !lng) return null

    return (
      <Marker position={[lat, lng]} icon={deliveryMotorIcon}>
        <Popup>موقعیت فعلی پیک</Popup>
      </Marker>
    )
  }

  // Fetch order and user
  useEffect(() => {
    post('/api/front/users/verify', {
      token: localStorage.getItem('token')
    })
      .then(res => {
        if (res.data.message !== 'احراز هویت با موفقیت انجام شد') navigate('/peyk')
      })
      .catch(() => navigate('/peyk'))

    post('/api/front/peyks/info', {
      phoneNumber: localStorage.getItem('phoneNumber')
    }).then(res => setName(res.data.data.name))

    get(`/api/front/order/details/${param.id}`).then(response => {
      setCustomerName(response.data.data.user[0].name)
      setAddress(response.data.data.orderWay.orderDetail.addressSelect)
      setPositionLat(Number(response.data.data.orderWay.orderDetail.selectedPosition[0]))
      setPositionLong(Number(response.data.data.orderWay.orderDetail.selectedPosition[1]))
    })
  }, [navigate, param.id])

  // Live location
  useEffect(() => {
    if (!navigator.geolocation) return

    const interval = setInterval(() => {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          setPeykLat(pos.coords.latitude)
          setPeykLong(pos.coords.longitude)
        },
        () => {},
        { enableHighAccuracy: true }
      )
    }, 5000)

    return () => clearInterval(interval)
  }, [])

  return (
    <div id='peyk'>
      <header className='header'>
        <section className='header__name'>
          <div>
            <img src={DeliveryIcon} alt='DeliveryIcon' />
          </div>
          <div className='profileName'>
            <span className='profileName__self'>{name}</span>
            <span className='profileName__tag'>سفیر کانولی</span>
          </div>
        </section>

        <section className='header__profile'>
          <Link to='/peyk/profile'>
            <img src={PeykProfileIcon} alt='PeykProfileIcon' />
          </Link>
        </section>
      </header>

      <main className='body current__page'>
        <div className='body__title'>سفارشات جاری</div>

        <div className='current'>
          <div className='current__text'>
            <span>{customerName}</span>
            <hr />
            <span>{address}</span>
          </div>

          <div className='current__map'>
            <MapContainer
              id='mapId'
              center={[restaurantLat, restaurantLong]}
              zoom={14}
            >
              <TileLayer url='https://{s}.tile.osm.org/{z}/{x}/{y}.png' />

              {postitionLat && postitionLong && (
                <RoutingMachine to={[postitionLat, postitionLong]} />
              )}

              <PeykMarker lat={peykLat} lng={peykLong} />
            </MapContainer>
          </div>

          <div className='current__button'>
            <button>تحویل داده شد</button>
          </div>
        </div>
      </main>

      <nav className='navbar'>
        <Link to='/peyk/orders' className='navbar__item'>
          <span><img src={PeykMenuOrderActive} alt='' /></span>
          <span className='navbar__item--active'>سفارشات</span>
        </Link>

        <Link to='/peyk/analytic' className='navbar__item'>
          <span><img src={PeykMenuAnalytic} alt='' /></span>
          <span>حسابداری</span>
        </Link>

        <Link to='/peyk/dashboard' className='navbar__item'>
          <span><img src={PeykHat} alt='' /></span>
          <span>سفیر</span>
        </Link>

        <Link to='/peyk/messages' className='navbar__item'>
          <span><img src={PeykMenuMessage} alt='' /></span>
          <span>پیام‌ها</span>
        </Link>

        <Link to='/peyk/orders' className='navbar__item'>
          <span><img src={PeykMenuOrderDone} alt='' /></span>
          <span>انجام شده</span>
        </Link>
      </nav>
    </div>
  )
}
